export interface CountdownTick {
  countdown: number;
  at: number;
}

export interface CountdownAnomaly {
  gapsMs: number[];
  worstDeviationMs: number;
}

const EXPECTED_TICK_MS = 1000;
const TOLERANCE_MS = 500;

export function findCountdownAnomaly(
  ticks: CountdownTick[],
  expectedMs = EXPECTED_TICK_MS,
  toleranceMs = TOLERANCE_MS
): CountdownAnomaly | null {
  if (ticks.length < 2) return null;

  const gapsMs = ticks
    .slice(1)
    .map((tick, i) => Math.round(tick.at - ticks[i].at));
  const worstDeviationMs = Math.max(
    ...gapsMs.map((gap) => Math.abs(gap - expectedMs))
  );

  return worstDeviationMs > toleranceMs ? { gapsMs, worstDeviationMs } : null;
}
